import { BodyText, Link } from '@paypalcorp/pp-react'
import PageMessage from 'ppbl/components/PageMessage'
import { useApplicationContext } from 'ppbl/hooks'
import { merge } from 'lodash-es'
import { trackPage, trackClick } from 'ppbl/utils/fpti-helper'
import { FPTI_EVENTS } from 'ppbl/utils/fptiEventNames'
import { getLocalizedText } from 'ppbl/utils/locale-helper'
import React, { useEffect } from 'react'
import clientLogger from 'ppbl/utils/client-logger'
import { interpolate } from 'ppbl/utils/string-helper'
import { isRenewalFlow, getPortalUrl } from 'ppbl/screens/__utils__'
import { pendingPageConstants } from 'ppbl/utils/constants'

const fptiData = {
  page: 'pendingPage',
  event_name: FPTI_EVENTS.PAGE.PENDING,
}

type Props = {
  applicationType: string
}

const PendingPage: React.FC<Props> = ({ applicationType }) => {
  const { data } = useApplicationContext()

  useEffect(() => {
    clientLogger.info(
      'Pending page is loaded - Application ID:',
      data?.applicationMetaData?.applicationId,
    )
    trackPage(
      merge(fptiData, {
        applicationId: data?.applicationMetaData?.applicationId,
      }),
    )
  }, [])

  const portalInfo = data?.applicationMetaData?.portalAccess

  const handleContinueToPortalClick = function () {
    trackClick(
      merge(fptiData, {
        component: `continueToPortal_pendingPage_button`,
        link: `continueToPortal_pendingPage_button`,
        applicationId: data?.applicationMetaData?.applicationId,
        event_name: FPTI_EVENTS.CLICK.NAVIGATION.CONTINUE_TO_PORTAL,
      }),
    )
    const applicationSubmitStatus = sessionStorage.getItem(
      'applicationSubmitStatus',
    )
    const portalUrl = getPortalUrl(portalInfo, applicationSubmitStatus)
    window.open(portalUrl, '_self')
    sessionStorage.setItem('mostRecentCompletedPage', 'pending')
  }

  return (
    <PageMessage
      type="contact"
      onPrimaryAction={
        isRenewalFlow(applicationType) && handleContinueToPortalClick
      }
      localization={{
        title: getLocalizedText('pending-page.title'),
        primaryText: getLocalizedText(`pending-page.continueBtn`),
      }}
    >
      <BodyText className="body__text">
        {interpolate(getLocalizedText('pending-page.bodyText1.text'), {
          phone: (
            <Link
              href={pendingPageConstants.phoneNumber.tel}
              size="md"
              secondary
              className="phone_link"
            >
              {pendingPageConstants.phoneNumber.phone}
            </Link>
          ),
          highlightWeekDayTime: (
            <b>{getLocalizedText('pending-page.highlightWeekDayTime')}</b>
          ),
          highlightWeekendTime: (
            <b>{getLocalizedText('pending-page.highlightWeekendTime')}</b>
          )
        })}
      </BodyText>
    </PageMessage>
  )
}

export default PendingPage
